import { createAction, props } from '@ngrx/store';

import { EmailPreference, UnsubscribeDetails } from '../states/notification-preferences.state';

export enum NotificationPreferencesActionTypes {
    GET_UNSUBSCRIBE_DETAILS = '[NOTIFICATION PREFERENCES] Get Unsubscribe Details',
    SET_UNSUBSCRIBE_DETAILS = '[NOTIFICATION PREFERENCES] Set Unsubscribe Details',
    UNSUBSCRIBE_EMAIL = '[NOTIFICATION PREFERENCES] Unsubscribe Email',
    UNSUBSCRIBE_EMAIL_SUCCESS = '[NOTIFICATION PREFERENCES] Unsubscribe Email Success',
    GET_EMAIL_PREFERENCES = '[NOTIFICATION PREFERENCES] Get Email Preferences',
    SET_EMAIL_PREFERENCES = '[NOTIFICATION PREFERENCES] Set Email Preferences',
    DELETE_EMAIL_PREFERENCES = '[NOTIFICATION PREFERENCES] Delete Email Preferences',
    DELETE_EMAIL_PREFERENCES_SUCCESS = '[NOTIFICATION PREFERENCES] Delete Email Preferences Success',
    SET_LOADING = '[NOTIFICATION PREFERENCES] Set Loading',
    SET_ERROR = '[NOTIFICATION PREFERENCES] Set Error',
    RESET_STATE = '[NOTIFICATION PREFERENCES] Reset State',
}

export const GetUnsubscribeDetails = createAction(NotificationPreferencesActionTypes.GET_UNSUBSCRIBE_DETAILS, props<{ token: string }>());

export const SetUnsubscribeDetails = createAction(
    NotificationPreferencesActionTypes.SET_UNSUBSCRIBE_DETAILS,
    props<{ unsubscribeDetails: UnsubscribeDetails }>()
);

export const UnsubscribeEmail = createAction(
    NotificationPreferencesActionTypes.UNSUBSCRIBE_EMAIL,
    props<{ token: string; email: string; preference: string }>()
);

export const UnsubscribeEmailSuccess = createAction(NotificationPreferencesActionTypes.UNSUBSCRIBE_EMAIL_SUCCESS);

export const GetEmailPreferences = createAction(NotificationPreferencesActionTypes.GET_EMAIL_PREFERENCES);

export const SetEmailPreferences = createAction(
    NotificationPreferencesActionTypes.SET_EMAIL_PREFERENCES,
    props<{ emailPreferences: EmailPreference[] }>()
);

export const DeleteEmailPreferences = createAction(
    NotificationPreferencesActionTypes.DELETE_EMAIL_PREFERENCES,
    props<{ preferences: { orgId: string; eventType: string; subscriptionId: string }[] }>()
);

export const DeleteEmailPreferencesSuccess = createAction(NotificationPreferencesActionTypes.DELETE_EMAIL_PREFERENCES_SUCCESS);

export const SetLoading = createAction(NotificationPreferencesActionTypes.SET_LOADING, props<{ loading: boolean }>());

export const SetError = createAction(NotificationPreferencesActionTypes.SET_ERROR, props<{ error: string | null }>());

export const ResetNotificationPreferencesState = createAction(NotificationPreferencesActionTypes.RESET_STATE);
